import {createRouter, createWebHashHistory} from 'vue-router'

import tijiao from './components/tijiao'
import index from './components/index'
import index2 from './components/index2'
import chaxun from './components/chaxun'
import baobei from './components/baobei'
import tianbao from './components/tianbao'

import kaihu from './components/kaihu'
import kaihuQuery from './components/kaihuQuery.vue'
import kaihuResult from './components/kaihuResult.vue'
import kaihuUpdate from './components/kaihuUpdate.vue'
import kaihuSuccess from './components/kaihuSuccess.vue'
import score from './components/score'
import scoreStart from './components/scoreStart.vue'
import scoreQuery from './components/scoreQuery.vue'
import scoreResult from './components/scoreResult.vue'
import scoreComplain from './components/scoreComplain.vue'
import scoreSuccess from './components/scoreSuccess.vue'

const router = createRouter({
    history: createWebHashHistory(),
    routes: [
        {
            path: '/index', name: 'index2',
            component: index2,
            meta: {
                title: '前置审查',
                keepAlive: true
            }
        },
        {
            path: '/', name: 'index',
            component: index,
            meta: {
                title: '首页',
                keepAlive: true
            }
        },
        {
            path: '/chaxun', name: 'chaxun',
            component: chaxun,
            meta: {
                title: '机构信息查询',
                keepAlive: true
            }
        },
        {path: '/tijiao',
            name: 'tijiao',
            component: tijiao,
            meta: {
                title: '申请申明',
                keepAlive: true
            }
        },
        {path: '/baobei',
            name: 'baobei',
            component: baobei,
            meta: {
                title: '资料填写',
                keepAlive: true
            }
        },
        {path: '/tianbao',
            name: 'tianbao',
            component: tianbao,
            meta: {
                title: '资料填写',
                keepAlive: true
            }
        },

        {path: '/kaihu',
            name: 'kaihu',
            component: kaihu,
            meta: {
                title: '机构开户信息填写',
                keepAlive: true
            }
        },
        {path: '/kaihuQuery',
            name: 'kaihuQuery',
            component: kaihuQuery,
            meta: {
                title: '机构开户进度查询',
                keepAlive: true
            }},
        {path: '/kaihuResult',
            name: 'kaihuResult',
            component: kaihuResult,
            meta: {
                title: '机构开户结果',
                keepAlive: true
            }
        },
        {path: '/kaihuUpdate',
            name: 'kaihuUpdate',
            component: kaihuUpdate,
            meta: {
                title: '机构开户信息修改',
                keepAlive: true
            }
        },
        {path: '/kaihuSuccess',
            name: 'kaihuSuccess',
            component: kaihuSuccess,
            meta: {
                title: '机构申请成功',
                keepAlive: true
            }
        },

        {path: '/score',
            name: 'score',
            component: score,
            meta: {
                title: '机构评分',
                keepAlive: true
            }
        },
        {path: '/scoreStart',
            name: 'scoreStart',
            component: scoreStart,
            meta: {
                title: '评分机构',
                keepAlive: true
            }
        },
        {path: '/scoreQuery',
            name: 'scoreQuery',
            component: scoreQuery,
            meta: {
                title: '机构评分进度查询',
                keepAlive: scoreQuery
            }
        },
        {path: '/scoreResult',
            name: 'scoreResult',
            component: scoreResult,
            meta: {
                title: '机构评分结果',
                keepAlive: true
            }
        },
        {path: '/scoreComplain',
            name: 'scoreComplain',
            component: scoreComplain,
            meta: {
                title: '机构评分申诉',
                keepAlive: true
            }
        },
        {path: '/scoreSuccess',
            name: 'scoreSuccess',
            component: scoreSuccess,
            meta: {
                title: '机构自评分成功',
                keepAlive: true
            }
        }
    ]
})

export default router
